import React from "react";
import { Navigate } from "react-router-dom";
import { useAuthSession } from "../hooks/useAuthSession";

interface RoleProtectedRouteProps {
  children: React.ReactNode;
  requiredRole: string;
  redirectTo?: string;
}

const RoleProtectedRoute: React.FC<RoleProtectedRouteProps> = ({ 
  children, 
  requiredRole, 
  redirectTo = "/" 
}) => {
  const { session, userRole } = useAuthSession();

  // If not logged in, redirect to login
  if (!session) {
    return <Navigate to="/login" replace />;
  }

  // If user doesn't have required role, redirect
  if (userRole !== requiredRole) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};

export default RoleProtectedRoute;
